<div id="header" class="header navbar" [style]="headerStyle">
    <div class="header-container">

        <ngb-alert type="warning" *ngIf="!(showGracePeriodWarning && gracePeriodMessage) && !automaticBillingInfoDismissed && subscriptionWarning" style="position: sticky; font-size: large; cursor: pointer;margin-bottom: 0px;"
                   (closed)="dismissAutomaticBillingInfo()" (click)="onSubscriptionWarningClick($event)" [dismissible]="true" [ngClass]="subscriptionSecondWarning ? 'subscriptionSecondWarning' : 'subscriptionWarning'">
            <strong class="warning-bold"><lucide-icon name="triangle-alert" [size]="20" style="display: inline-flex; vertical-align: middle;"></lucide-icon>
                {{ 'layout.portal-header.subscription-warning' | translate }}
            </strong><span class="warning-regular"> {{subscriptionWarning}}
            </span>
            <span
                *ngIf="canViewIn2SubscriptionPage || canManageIn2SubscriptionPage"
                class="text-underline warning-regular"
            >
                {{ 'layout.portal-header.learn-more' | translate }}
            </span>
        </ngb-alert>

        <!-- Grace Period Warning Alert -->
        <ngb-alert type="danger" *ngIf="showGracePeriodWarning && gracePeriodMessage"
                   style="position: sticky; font-size: large; cursor: pointer; margin-bottom: 0px;"
                   [dismissible]="false" class="grace-period-warning">
            <strong class="warning-bold"><lucide-icon name="triangle-alert" [size]="20" style="display: inline-flex; vertical-align: middle;"></lucide-icon>
                {{ 'layout.portal-header.grace-period-warning' | translate }}
            </strong>
            <span class="warning-regular" [innerHTML]="gracePeriodMessage"></span>
        </ngb-alert>
        <div class="header-bar">
        <!-- menu button -->
        <div
            [ngClass]="{
                hidden: !isMobile
            }"
            class="menubtn menubtnnav"
            (click)="toggleNavigation()"
        >
            <span class="icon-holder"><lucide-icon name="menu" [size]="26"></lucide-icon></span>
        </div>

            <!-- Branch Selector (desktop only) -->
            <div class="header-branch-selector" *ngIf="branches && branches.length > 1"
                 [class.dropdown-open]="isBranchDropdownOpen">
                <button
                    class="branch-trigger"
                    (click)="toggleBranchDropdown()"
                    [class.open]="isBranchDropdownOpen"
                >
                    <lucide-icon name="map-pin" [size]="15"></lucide-icon>
                    <span class="branch-label">{{ selectedBranchName }}</span>
                    <lucide-icon name="chevron-down" [size]="14" class="branch-chevron"></lucide-icon>
                </button>
                <div class="branch-dropdown">
                    <div class="branch-dropdown-header">
                        {{ 'layout.sidenav.switch-branch' | translate }}
                    </div>
                    <div
                        *ngFor="let branch of branches"
                        class="branch-option"
                        [class.selected]="branch.id === selectedBranchId"
                        (click)="onBranchChange(branch.id); closeBranchDropdown()"
                    >
                        <lucide-icon name="check" [size]="14" class="branch-check"></lucide-icon>
                        <span>{{ branch.name }}</span>
                    </div>
                </div>
            </div>

            <!-- Search (centered) -->
            <div class="header-search">
                <smartsearch [data]="smartSearchData"></smartsearch>
            </div>

            <!-- Right section: Help + User menu -->
            <div class="nav-right">
                <div class="header-help-wrapper">
                    <button class="header-help-btn" (click)="toggleHelpPanel($event)">
                        <lucide-icon name="circle-help" [size]="20"></lucide-icon>
                        <span>{{ 'layout.portal-header.need-help' | translate }}</span>
                    </button>
                    <popup-panel
                        [isOpen]="isHelpPanelOpen"
                        (closed)="closeHelpPanel()"
                        panelClass="help-menu-panel"
                        width="220px"
                    >
                        <div class="help-menu">
                            <button class="help-menu-item" (click)="openHelp(); closeHelpPanel()">
                                <lucide-icon name="circle-help" [size]="20"></lucide-icon>
                                <span>{{ 'layout.portal-header.support' | translate }}</span>
                            </button>
                            <button class="help-menu-item" (click)="openRequestFeature(); closeHelpPanel()">
                                <lucide-icon name="lightbulb" [size]="20"></lucide-icon>
                                <span>{{ 'layout.portal-header.request-feature' | translate }}</span>
                            </button>
                            <button class="help-menu-item" (click)="openRequestAddOn(); closeHelpPanel()">
                                <lucide-icon name="package-plus" [size]="20"></lucide-icon>
                                <span>{{ 'layout.portal-header.request-addon' | translate }}</span>
                            </button>
                        </div>
                    </popup-panel>
                </div>
                <button (click)="toggleProfilePanel($event)" class="user-menu-trigger">
                    <span class="user-icon"><lucide-icon name="user" [size]="24"></lucide-icon></span>
                    <span class="user-name">{{ loggedInUser }}</span>
                    <span class="chevron"><lucide-icon name="chevron-down" [size]="20"></lucide-icon></span>
                </button>
            </div>
        </div>
    </div>
</div>

<popup-panel
    [isOpen]="isProfilePanelOpen"
    (closed)="closeProfilePanel()"
    panelClass="profile-menu-panel"
    width="300px"
>
    <div class="profile-menu">
        <!-- Dynamic settings items -->
        <div
            appSecurityTag
            [securityTags]="settingMenuItem.securityTags"
            *ngFor="let settingMenuItem of settingsMenu"
        >
            <a
                class="profile-menu-item"
                *ngIf="
                    !settingMenuItem.openInNewTab &&
                    (!settingMenuItem.checkVisibility ||
                        (settingMenuItem.checkVisibility &&
                            settingMenuItem.visible))
                "
                [routerLink]="[settingMenuItem.routerLink]"
                (click)="closeProfilePanel()"
            >
                <lucide-icon
                    [name]="settingMenuItem.icon"
                    [size]="settingMenuItem.iconSize || 16"
                    [style.margin.px]="settingMenuItem.iconSize ? (16 - settingMenuItem.iconSize) / 2 : null"
                ></lucide-icon>
                <span>{{ settingMenuItem.label | translate }}</span>
            </a>

            <a
                class="profile-menu-item"
                *ngIf="
                    settingMenuItem.openInNewTab &&
                    !settingMenuItem.externalUrl &&
                    (!settingMenuItem.checkVisibility ||
                        (settingMenuItem.checkVisibility &&
                            settingMenuItem.visible))
                "
                (click)="settingsMenuItemClicked(settingMenuItem); closeProfilePanel()"
            >
                <lucide-icon
                    [name]="settingMenuItem.icon"
                    [size]="settingMenuItem.iconSize || 16"
                    [style.margin.px]="settingMenuItem.iconSize ? (16 - settingMenuItem.iconSize) / 2 : null"
                ></lucide-icon>
                <span>{{ settingMenuItem.label | translate }}</span>
            </a>

            <!-- External link: a real <a href> so it can be focused with the keyboard and never opens with window.opener -->
            <a
                class="profile-menu-item"
                *ngIf="
                    settingMenuItem.externalUrl &&
                    (!settingMenuItem.checkVisibility ||
                        (settingMenuItem.checkVisibility &&
                            settingMenuItem.visible))
                "
                [href]="settingMenuItem.externalUrl"
                target="_blank"
                rel="noopener noreferrer"
                (click)="closeProfilePanel()"
            >
                <lucide-icon
                    [name]="settingMenuItem.icon"
                    [size]="settingMenuItem.iconSize || 16"
                    [style.margin.px]="settingMenuItem.iconSize ? (16 - settingMenuItem.iconSize) / 2 : null"
                ></lucide-icon>
                <span>{{ settingMenuItem.label | translate }}</span>
            </a>

            <mat-divider
                *ngIf="
                    !settingMenuItem.checkVisibility ||
                    (settingMenuItem.checkVisibility && settingMenuItem.visible)
                "
            ></mat-divider>
        </div>

        <!-- Language Selector -->
        <div id="profile-menu-language-switch" class="profile-menu-item language-item" (click)="langSelector.openMenu()">
            <lucide-icon name="globe" [size]="20"></lucide-icon>
            <span>{{ 'layout.portal-header.language' | translate }}</span>
            <language-selector #langSelector></language-selector>
        </div>
        <mat-divider></mat-divider>

        <!-- Help (mobile only — on desktop these are in the header bar) -->
        <div class="profile-menu-help-section">
            <button class="profile-menu-item" (click)="openHelp(); closeProfilePanel()">
                <lucide-icon name="circle-help" [size]="20"></lucide-icon>
                <span>{{ 'layout.portal-header.support' | translate }}</span>
            </button>
            <button class="profile-menu-item" (click)="openRequestFeature(); closeProfilePanel()">
                <lucide-icon name="lightbulb" [size]="20"></lucide-icon>
                <span>{{ 'layout.portal-header.request-feature' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
        </div>

        <!-- Change Password -->
        <button class="profile-menu-item" (click)="changePassword(); closeProfilePanel()">
            <lucide-icon name="lock" [size]="16"></lucide-icon>
            <span>{{ 'layout.portal-header.change-password' | translate }}</span>
        </button>
        <mat-divider></mat-divider>

        <!-- Logout -->
        <button class="profile-menu-item logout-item" (click)="logout()">
            <lucide-icon name="power" [size]="16"></lucide-icon>
            <span>{{ 'layout.portal-header.logout' | translate }}</span>
        </button>
    </div>
</popup-panel>

